import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { WarningIcon, CheckMarkIcon } from './Icons';

interface MessageProperties {
    isSuccess?: boolean;
    title?: string;
    message: string | JSX.Element;
    button?: {
        text: string;
        href: string;
    };
}

export function Message(props: MessageProperties) {
    const icon: JSX.Element | null = !props.isSuccess ?
            <WarningIcon width="24px" height="20px" /> :
            <CheckMarkIcon width="21px" height="20px" />;

    const cssClass: JSX.Element | string = !props.isSuccess ? 'info__box warning' : 'info__box success';
    return (
        <div className={cssClass} role="alert">
            <div>
                {icon}
                <div>
                    {props.title && <strong>{props.title}</strong>}
                    <p>{props.message}</p>
                </div>
            </div>
            {props.button && <NavLink className="btn" to={props.button.href}>{props.button.text}</NavLink>}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/webportal/components/common/Message.tsx